import {
    CartQuery as SourceCartQuery,
} from 'SourceQuery/Cart.query';
import { Field } from '@tilework/opus';

export class CartQuery extends SourceCartQuery {
    _getCartItemPricesFields() {
        return [
            this._getCartItemPriceField(),
            this._getCartItemRowTotalField(),
            this._getCartItemRowTotalInclTaxField(),
            this._getCartItemTotalDiscountField(),
            this._getCartItemOriginalPriceField()
        ];
    }

    _getCartItemOriginalPriceField() {
        return new Field('original_price')
            .addFieldList(this._getOriginalPriceField());
    }

    _getOriginalPriceField() {
        return [
            'value',
            'currency',
        ];
    }

    _getCartItemsFields() {
        return [
            'id',
            'uid',
            'sku',
            'quantity',
            'freegift_description',
            this._getCartItemProduct(),
            this._getCartItemPricesField(),
            this._getCartDownloadableProductLinkField(),
            this._getCartBundleProductFragment(),
            this._getCartConfigurableProductFragment(),
            this._getCartVirtualProductFragments(),
            this._getCartSimpleProductFragments(),
        ];
    }
}

export default new CartQuery();
